import { render, staticRenderFns } from "./CONTACT.vue?vue&type=template&id=03730b64&"
import script from "./CONTACT.vue?vue&type=script&lang=js&"
export * from "./CONTACT.vue?vue&type=script&lang=js&"
import style0 from "./CONTACT.vue?vue&type=style&index=0&id=03730b64&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports